(function ($) {
  const locale_theme = window.theme.locale;

  /**Menu**/
  function customSubMenu() {
    $(".nav-dropdown.nav-dropdown--first").each(function (index) {

      if (!$(this).find(".nav-dropdown--second").length) {
        $(this).parent().addClass("not-dropdown-second");
      }
    });
  }

  customSubMenu();

  /**Search page**/
  $('.search__form .input-group__submit').on('click', function () {
    var input_search = $(".search__form .form__input").val().replace("/", " ");
    $(".search__form .form__input").val(input_search);
  });

  /**FOOTER**/
  $('.menu_links > h2').on('click', function () {
    var parent = $(this).parent(),
      windowWidth = window.innerWidth;

    if (windowWidth <= 800) {
      parent.toggleClass("open");
    }

  });


  /**Home page**/

  /**New product**/
  var initNewProducts = function (domElement) {
    if (domElement.length === 0) {
      return;
    }

    domElement.slick({
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      mobileFirst: true,
      infinite: false,
      centerMode: false,
      centerPadding: '0',
      slidesToShow: 2,
      slidesToScroll: 1,
      pauseOnHover: false,
      accessibility: false,
      useCSS: true,
      prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
      nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
      responsive: [
        {
          breakpoint: 320,
          settings: 'unslick'
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
          }
        }
      ]

    })
  };

  /**Promotion Products**/
  var initPromotion = function (domElement) {
    var productList = domElement.find('.list-products');
    if (productList.hasClass('slick-initialized')) {
      productList.slick('unslick');
    }
  };


  if ($("body").hasClass("template-index")) {
    initPromotion($('.shopify-section__promotions-product'));
    initNewProducts($('.section-new-products .list-products'));
  }

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return 1;
  };

  $(document).ready(function () {
    const eleCloseSearch = $('.header-search__close');
    if(eleCloseSearch.length){
      eleCloseSearch.on('click', function(){
        $('.header__link.search-form a').trigger('click');
      })
    }
    
    const customerInfoElm = $('#customer-infor');
    const customerInfo = {
      customerId: customerInfoElm.data('customer-id'),
      partnerCode: customerInfoElm.data('partner-code'),
      customerEmail: customerInfoElm.data('customer-email'),
    };

    setTimeout(function() {
      checkWishlistStatus(customerInfo);
      getWishlist(customerInfo);
    }, 1000);

    addWishlist(customerInfo);
    removeWishlist(customerInfo);

    //remove provine
    if ($(".address_form").length) {
      $(".address_form").find('option[value="Putrajaya"]').remove();
    }


    if ($(".review-tab-title").length) {
      $(".review-tab-title").hide();
      $(".review-tab-m").parents(".tabs__nav-item-m").hide();
    }

    $(".review-tab-title").on("click", function () {
      showReview(false);
      const detail = {
        type: 'reviewsClick',
        label: ''
      }
      dispatchEvent(detail);
    });



    checkRating();

    if ($("body").hasClass("template-product")) {
      if ($(".review-tab-title").hasClass("active")) {
        showReview(true);
      }
      else {
        showReview(false);
      }
    }

  });

  $(window).scroll(function () {

  });

  /**Disable Scroll on mobile**/

  function disableScroll() {
    $('.header__nav-toggle').on('touchmove', function (evt) {
      evt.preventDefault();
    });
  }

  function enableScroll() {
    $('.header__nav-toggle').off('touchmove', function (evt) {
      evt.preventDefault();
    });
  }

  $('.header__nav-toggle').on('click', function (evt) {
    checkDevice();
  });

  function checkDevice() {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    if (windowWidth <= 1024 && $('.sidebar-nav').hasClass('sidebar-nav--open')) {
      disableScroll();
    }
    else {
      enableScroll();
    }
  }

  function closeMinicart() {
    if (headerSearch.hasClass('header-search--open')) {
      headerSearch.removeClass('header-search--open');
    }
    if (miniCart.hasClass('mini-cart--open')) {
      miniCart.removeClass('mini-cart--open');
    }
    if (userLink.hasClass('open')) {
      userLink.removeClass('open');
      navUser.hide();
    }

    $('.page__overlay').removeClass('page__overlay--open');

    $("body").removeClass('no-scroll');

  }

  $('.page__overlay').bind('touchstart', function (e) {
    closeMinicart();
  });

  // AA tracking button for mini cart
  $(document).on("click", '.close-minicart', function (event) {
    const detail = {
      type: 'continueShopping',
      label: 'continueShopping'
    }
    dispatchEvent(detail);
    closeMinicart();
  });
  
  $(document).on("click", '.mini-cart__buttons .button--checkout', function (event) {
    const detail = {
      type: 'proceedCheckout',
      label: 'proceedCheckout'
    }
    dispatchEvent(detail);
  });

  $(window).resize(function () {
    if ($("body").hasClass("template-index")) {
      initNewProducts($('.section-new-products .list-products'));
    }
    checkDevice();
    showCodeContent(true);
    showReview(false);
  });

  /**Nav User Drop Down in Header**/
  var userLink = $('.user__link');
  var userDropdown = userLink.find('.link');
  var navUser = userLink.find('.nav-dropdown');
  var miniCart = $(".mini-cart");
  var headerSearch = $(".header-search");


  $(document).click(function (e) {

    if (!e) e = window.event;

    if ($(e.target).hasClass("nav-dropdown__link")) {
      //sub menu
      window.location.href = $(e.target).attr("href");
    }
    else if ($(e.target).hasClass("user__link") || $(e.target).parents(".user__link").length
      || $(e.srcElement).parents(".user__link").length
      || $(e.srcElement).hasClass("user__link")) {

      if (headerSearch.hasClass('header-search--open')) {
        headerSearch.removeClass('header-search--open');
      }

      if (miniCart.hasClass('mini-cart--open')) {
        miniCart.removeClass('mini-cart--open');
      }

      if (userLink.hasClass('open')) {
        userLink.removeClass('open');
        $("body").removeClass('no-scroll');
        navUser.hide();
        $('.page__overlay').removeClass('page__overlay--open');
      }
      else {
        userLink.addClass('open');
        $("body").addClass('no-scroll');
        navUser.show();
        $('.page__overlay').addClass('page__overlay--open');
      }
    }
    else if ($(e.target).hasClass("search-form") || $(e.target).parents(".search-form").length) {

      if (miniCart.hasClass('mini-cart--open')) {
        miniCart.removeClass('mini-cart--open');
      }

      if (userLink.hasClass('open')) {
        userLink.removeClass('open');
        navUser.hide();

      }
    }
    else {
      if ($(e.target).hasClass("page__overlay")) {
        if (headerSearch.hasClass('header-search--open')) {
          headerSearch.removeClass('header-search--open');
        }
        if (miniCart.hasClass('mini-cart--open')) {
          miniCart.removeClass('mini-cart--open');
        }
        if (userLink.hasClass('open')) {
          userLink.removeClass('open');
          navUser.hide();
        }
        $('.page__overlay').removeClass('page__overlay--open');
        $("body").removeClass('no-scroll');
      }

      else if ($(e.target).hasClass("mini-cart-menu") || $(e.target).parents(".mini-cart-menu").length) {
        if (headerSearch.hasClass('header-search--open')) {
          headerSearch.removeClass('header-search--open');
        }
        if (userLink.hasClass('open')) {
          userLink.removeClass('open');
          navUser.hide();
        }
      }
    }

  });

  function phone_validate(phno) {
    var regexPattern = new RegExp(/^[0-9]+$/);    // regular expression pattern
    return regexPattern.test(phno);
  }

  function getValidatePartnerQuota(cartItems, callback, token) {
    const customerInfoElm = $('#customer-infor');
  
    const customerInfo = {
      customerId: customerInfoElm.data('customer-id'),
      partnerCode: customerInfoElm.data('partner-code'),
      customerEmail: customerInfoElm.data('customer-email'),
    };
  
    if(!customerInfo.customerId) {
      callback();
      return;
    };
  
    const dataItems = cartItems.map(item => ({
      variantid: item.variant_id,
      productid: item.product_id,
      quantity: item.quantity
    }));
  
    const storeId = window.partner.storeId.toString();
    const dataString = JSON.stringify({
      storeid: storeId,
      customeremail: customerInfo.customerEmail,
      partnerCode: customerInfo.partnerCode,
      cartitemids: dataItems
    });
  
    $.ajax({
      method: 'POST',
      async: false,
      url: `${window.partner.omsValidateOrderQuotation}`,
      headers: {
        'Authorization': `Bearer ${token}`,
        'issuer': storeId,
        'Accept-Language': 'en-US'
      },
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        'jsonstr': dataString
      })
  
    }).done(result => {
      if (result) {
        const valueReult = JSON.parse(result.value);
        callback(valueReult[0]);
      }
    })
    .fail(err => {
      console.log('err: ', err);
    });
  };

  function ValidatePartnerQuota(hrefUrl, id, increase_quantity, currentQty, self) {
    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart) {
      const newCartItems = cart.items?.filter(ele => ele.properties['_new_line_price'] && ele.properties['_new_line_price'] != 'NaN');

      const increaseItem = newCartItems.find((item) => {
        return item.id == id
      });

      if (increaseItem) {
        increaseItem.quantity = parseInt(increase_quantity);
      }

      window.getOMSAccessToken().then((token) => {
        getValidatePartnerQuota(newCartItems, function(result) {
          if(result && result.validTotalQuota.toLowerCase() === "false") {
            if(currentQty) {
              self.val(currentQty);
            }

            self.parent().find('.error_Msg').css("display", "block");
            self.addClass("has-error");
  
            alert('The total/yearly quota has exceeded.');
            
            return;
          }
          
          if (result) {
            let strError = '';
            const arrayInValidVariantIds = JSON.parse(result.inValidVariantIds.replace(',]', ']'));
  
            if (arrayInValidVariantIds && arrayInValidVariantIds.length > 0) {
              arrayInValidVariantIds.forEach(element => {
                const dataItem = newCartItems.find(item => item.variant_id == element);
  
                if (dataItem) {
                  strError += 'The product "' + dataItem.title + '" has exceeded category quota.\n';
                }
              });
  
              if (strError.length > 0) {
                if(currentQty) {
                  self.val(currentQty);
                }

                self.parent().find('.error_Msg').css("display", "block");
                self.addClass("has-error");
  
                alert(strError);
                return;
              }
            }
            
            window.location.href = hrefUrl;
            
          }
        }, token);        
      }).catch(err => console.log('error when call get OMS access token', err));

    });
  }

  //update quantity in cart page

  $(".quantity-selector .decrease-quantity").click( function(event){
    event.preventDefault();

    $(this).parent().find('.error_Msg').hide();

    var link = $(this).attr("data-link"),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).data('quantity')
        inventory_quantity = parseInt($(this).data('inventory-quantity'));

    var current_quantity = parseInt($(this).parent().find('input[name="update_quantity"]').val());

    if (current_quantity != "" && phone_validate(current_quantity)) {
      if (current_quantity > inventory_quantity) {
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      } else if (current_quantity > 0) {
        var decrease_quantity = current_quantity - 1;

        window.location.href = link + "&quantity=" + decrease_quantity + "&properties[_new_line_price]=" + decrease_quantity * newPrice;
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block");
        $(this).addClass("has-error");
      }
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block");
      $(this).addClass("has-error");
    }
  });

  $(".quantity-selector .increase-quantity").click( function(event){
    event.preventDefault();

    $(this).parent().find('.error_Msg').hide();

    var inventory_quantity = $(this).data('inventory-quantity'),
        link = $(this).attr("data-link"),
        id = $(this).attr("data-id"),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).data('quantity');

    var current_quantity = parseInt($(this).parent().find('input[name="update_quantity"]').val());

    inventory_quantity = parseInt(inventory_quantity);

    if (current_quantity != "" && phone_validate(current_quantity)) {
      if (current_quantity >= inventory_quantity) {
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      } 
      else if (current_quantity > 0) {
        var increase_quantity = current_quantity + 1;

        const url = link + "&quantity=" + increase_quantity + "&properties[_new_line_price]=" + increase_quantity * newPrice;

        ValidatePartnerQuota(url, id, increase_quantity, undefined , $(this));
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block");
        $(this).addClass("has-error");
      }
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block");
      $(this).addClass("has-error");
    }
  });
  
  $(".quantity-selector__current-quantity").keypress(function () {

    $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').hide();
    $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text("");
  });

  $(".quantity-selector__current-quantity").on('focusout', function(event){
    event.preventDefault();

    var link = $(this).attr("data-link"),
        id = $(this).data('id'),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = parseInt($(this).val()),
        inventoryQty = parseInt($(this).attr("data-inventory-quantity"));

    var currentQty = parseInt($(this).data('value'));

    if (phone_validate(quantity) && quantity > 0 ) {
      if (quantity > inventoryQty) {
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      } else {
        $(this).parent().find('.error_Msg').hide(); // hides error msg if validation is true
        $(this).removeClass("has-error");
  
        if (phone_validate(quantity)) {
          const url = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;
  
          ValidatePartnerQuota(url, id, quantity, currentQty, $(this));
        }
      }
    } else {
      $(this).parent().find('.error_Msg').css("display", "block");   // shows validation msg if validation is false
      $(this).addClass("has-error");
    }
  });

  // AA tracking
  $(".cart__items a.link").click(function (e) {
    const dataType = $(this).data('type');
    let carData = [];
    $.ajax({
      method: 'GET',
      async: false,
      url: '/cart.js',
      dataType: 'json'
    }).done(function (cart) {
      if (cart) {
        carData = cart.items;
      }
    });

    let variantValue;
    let type;
    switch(dataType) {
      case 'reduce':
        variantValue = $($(this).parents().eq(2)).data("variant-id");
        type = 'unitChangeMinus';
        break;
      case 'increase':
        variantValue = $($(this).parents().eq(2)).data("variant-id");
        type = 'unitChangePlus';
        break;
      case 'wishlist':
        variantValue = $($(this).parents().eq(1)).data("variant-id");
        if ($(this).hasClass( "wishlist_collections") && $(this).hasClass( "btn-active")) {
          type = 'favoriteRemove';
        } else {
          type = 'favoriteAdd';
        }
        break;
      case 'delete':
          variantValue = $($(this).parents().eq(1)).data("variant-id");
          type = 'unitDelete';
        break;
    }
    
    const data = carData?.find(ele => ele.variant_id == variantValue);
    if (data) {
      const dataDetail = {
        type: type,
        sku: data.sku,
        model: $(`input[name="model_${data.variant_id}"]`).val(),
        superModel: $(`input[name="superModel_${data.variant_id}"]`).val(),
        category: $(`input[name="sixdcode_${data.variant_id}"]`).val()
        // category: data.product_type.toString()
      };
      
      var event = new CustomEvent("cartEvent", {
        detail: dataDetail
      });
      document.dispatchEvent(event);
    }
  });

  $(".header__logo-link, .header__main-nav a.link, .nav-dropdown__item a.nav-dropdown__link").click(function () {
    let detail = {};
    if ($(this).hasClass("header__logo-link")) {
      detail = {
        type: 'headerHome',
        label: ''
      };
    } else {
      const name = $(this).attr("data-title");
      detail = {
        type: 'headerCategory',
        label: name
      };
    }
    dispatchEvent(detail);
  });

  $(`.header__link.search-form a.link, .header__link.wishlist a.link, .header__link.mini-cart-menu a.link, 
  .header__link.user__link a.nav-dropdown__link.link`).click(function () {
    let detail;
    if ($(this).attr('aria-label') === 'Search') {
      detail = {
        type: 'headerSearch',
        label: ''
      };
    } else if ($(this).attr('href') === '/pages/wishlist') {
      detail = {
        type: 'headerWishlist',
        label: ''
      };
    } else if ($(this).attr('aria-label') === 'Giỏ hàng') {
      detail = {
        type: 'headerCart',
        label: ''
      };
    } else if ($(this).attr('alt') === 'Sign In') {
      detail = {
        type: 'headerSignIn',
        label: ''
      };
    } else if ($(this).attr('alt') === 'Register') {
      detail = {
        type: 'headerRegister',
        label: ''
      };
    }

    if (detail) {
      dispatchEvent(detail);
    }
  });

  $(`.fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev[alt="Prev"], 
  .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next[alt="Next"]`).click(function () {
    let detail;
    const type = $(this).attr("alt");
    if (type === "Next") {
      detail = {
        type: 'sliderArrow',
        label: 'Next'
      };
    } else {
      detail = {
        type: 'sliderArrow',
        label: 'Previous'
      };
    }
    dispatchEvent(detail);
  });

  $('.product-item__see-more.button-wrapper, .product-item__title a[class="link"]').click(function () {
    let modelName;
    if ($(this).is('.product-item__see-more, .button-wrapper')) {
      modelName = $(this).parent().find('.product-item__info .product-item__title a[class="link"]').html();
    } else {
      modelName = $(this).html();
    }

    const detail = {
      type: 'viewDetail',
      label: modelName
    };
    dispatchEvent(detail);
  });

  $('.collection__filter.styled-select.collection-sort-by select').change(function () {
    const detail = {
      type: 'sortingClick',
      label: ''
    };
    dispatchEvent(detail);
  });

  $('.fs-slideshow__plyr-container').click(function() {
    const titleVideo = $(this).find('iframe').attr('title');
    const detail = {
      type: 'videoClick',
      label: titleVideo
    }
    dispatchEvent(detail);
  });

  $(`#shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev.slick-arrow, 
  #shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next.slick-arrow`).click(function () {
    let sliderArrow;
    const type = $(this).attr("title");
    if (type == "Prev") {
      sliderArrow = "Previous";
    } else {
      sliderArrow = "Next";
    }

    const detail = {
      type: 'sliderArrow',
      label: sliderArrow
    }
    dispatchEvent(detail);
  });

  $('.styled-select.styled-select--secondary select.single-option-selector').change(function () {
    const sizeSelect = $(this).val();
    const detail = {
      type: 'screenSize',
      label: sizeSelect
    }
    dispatchEvent(detail);
  });

  $('.product__slide-wrapper').click(function() {
    const detail = {
      type: 'carouselClick',
      label: ''
    }
    dispatchEvent(detail);
  });

  $('.quantity-selector a[data-action="increase-product-quantity"], .quantity-selector a[data-action="decrease-product-quantity"]').click(function () {
    let unitChange;
    var parent = $(this).parents('.product__details');
    if ($(this).attr('data-action') == 'increase-product-quantity') {
      unitChange = 'Plus';
    } else {
      unitChange = 'Minus';
    }

    const detail = {
      type: 'unitChange',
      label: unitChange,
      model: parent.find(`input[name^="model_"]`).val(),
      superModel: parent.find(`input[name^="superModel_"]`).val(),
      category: parent.find(`input[name^="sixdcode_"]`).val(),
    }
    dispatchEvent(detail);
  });

  $('.form__control.variant-colour .product__available-colors input[type="radio"]').change(function () {
    const color = $(this).val();
    const detail = {
      type: 'colorSwatch',
      label: color
    }
    dispatchEvent(detail);
  });

  $('body[class^="product"] li.tabs__nav-item').click(function () {
    const tabName = $(this).html().trim();
    //there was another event for Reviews
    if (tabName !== 'Reviews') {
      const detail = {
        type: 'stickynav',
        label: tabName
      };
      dispatchEvent(detail);
    }
  });

  $('.checkout-btn .button--continue-shoping').click(function () {
    const detail = {
      type: 'continueShopping',
      label: 'continueShopping'
    }
    dispatchEvent(detail);
  });

  function dispatchEvent(dataDetail) {
    var event = new CustomEvent("linkInteraction", {	
      detail: dataDetail	
    });	

    document.dispatchEvent(event);	
  };
  // End AA Tracking 

  $(".cart__checkout-button").on("click", function (e) {
    e.preventDefault();

    if ($(".quantity-selector__current-quantity").hasClass("has-error")) {
      return false;
    }

    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart) {
      const skuValue = cart.items.map(element => element.sku.toString());
      const modelValue = cart.items.map(element => $(`input[name="model_${element.variant_id}"]`).val());
      const superModelValue = cart.items.map(element => $(`input[name="superModel_${element.variant_id}"]`).val());
      const categoryValue = cart.items.map(element => $(`input[name="sixdcode_${element.variant_id}"]`).val());
      const quantityValue = cart.items.map(element => element.quantity.toString());
      const discountValue = cart.items.map(element => element.total_discount.toString());
      const priceValue = cart.items.map(element => $(`input[name="retailPrice_${element.variant_id}"]`).val());
      const discountpriceValue = cart.items.map(element => $(`input[name="sellingPrice_${element.variant_id}"]`).val());


      const detailItems = {
        sku: skuValue,
        model: modelValue,
        superModel: superModelValue,
        quantity: quantityValue,
        price: priceValue,
        category: categoryValue,
        discount: discountValue,
        discountprice: discountpriceValue,
        loyaltyPoints: 0
      };

      var event = new CustomEvent("checkoutEvent", {
        detail: detailItems 
      });
      document.dispatchEvent(event);

      checkoutSubmit();
    });
  });

  function checkoutSubmit() {
    const ps5InputValidate = $('input[name="ps5_validate"]').val();
    if($('button.cart__checkout-button').length > 0 && ps5InputValidate == 'false') {
      window.location.href = "/checkout";
    } else if($('a.cart__checkout-button').length > 0) {
      var hrefLink = $('a.cart__checkout-button').attr('href');
      window.location.href = hrefLink;
    }
  };

  $(".main-menu__links > li").click(function () {

    setTimeout(function () {
      checkDevice();
    }, 500);
  });


  function loginWishlist() {
    if ($('.customer-logout-in').length > 0) {
      $('.wishlist-modal').click(function (e) {
        var container = $(".wishlist-modal .content");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.wishlist-modal').removeClass('wishlist-popup-wrapper');
        }
      });

      $(".wishlist_login").on("click", function (e) {
        e.preventDefault();

        $(".wishlist-modal").toggleClass('wishlist-popup-wrapper');

        $(".wishlist-modal .close-popup").on("click", function () {
          $(".wishlist-modal").removeClass('wishlist-popup-wrapper');
        });
      });
    }
  }

  loginWishlist();

  function addWishlist(customerInfo) {
    const addWishlistSlt = '.wishlist_collections';

    $(document).off('click.addWishlist', addWishlistSlt).on('click.addWishlist', addWishlistSlt, function(e) {
      e.preventDefault();

      const self = $(this);
      self.addClass('disabled');
      self.find('.tooltip').text(window.languages.added);

      if(!self.hasClass('btn-active')) {
        const productId = self.data('product-id'),
              ProductHandle = self.data('product-handle'),
              variantId = self.data('variant-id');

        apiRequest.post('wishlist', {
          "product_id": productId,
          "variant_id": variantId,
          "handle": ProductHandle
        })
        .then(function(res){
          if(res.status) {
            self.addClass('btn-active');
  
            let wishlistCount = $('.header__secondary-nav .wishlist__count').text();
            wishlistCount = parseInt(wishlistCount) + 1;
  
            $.cookie("els", wishlistCount);
            $('.wishlist__count').text(wishlistCount);
  
            updateWishlistStatus(true, $(`${addWishlistSlt}[data-variant-id=${variantId}]`));
          }

        })
        .fail((err) => {
          console.log('error when call api add WishlistMetafields_Partner', err);
        })
        .always(() => {
          self.removeClass('disabled');
        });        
      }
    })
  }


  function removeWishlist(customerInfo){
    const removeWishlistSlt = '.wishlist_collections.btn-active';

    $(document).off('click.removeWishlist', removeWishlistSlt).on('click.removeWishlist', removeWishlistSlt, function(e) {
      e.preventDefault();
      
      const self = $(this);
      self.addClass('disabled');
      self.find('.tooltip').text(window.languages.removed);

      const productHandle = self.data('product-handle'),
            variantId = self.data('variant-id');


      apiRequest.delete('wishlist', {
        'handle': productHandle,
        'variant_id': variantId
      }).then(function(res){
        if(res.status) {
          self.removeClass('btn-active');
  
          let wishlistCount = $('.header__secondary-nav .wishlist__count').text();
          wishlistCount = parseInt(wishlistCount) - 1;
  
          $.cookie("els", wishlistCount);
          $('.wishlist__count').text(wishlistCount);
  
          updateWishlistStatus(false, $(`.wishlist_collections[data-variant-id=${variantId}]`));
        }
      })
      .fail((err) => {
        console.log('error when call api remove WishlistMetafields_Partner', err);
      })
      .always(() => {
        self.removeClass('disabled');
      });

      if(self.closest('.wishlist-content').length) {
        self.closest('.grid__cell').remove();
      }
      
    });
  }

  function updateWishlistStatus(isActive, elms) {
    if(isActive) {
      elms.addClass('btn-active');
      elms.find('.tooltip').text(window.languages.removeWishlistText);
    }
    else {
      elms.removeClass('btn-active');
      elms.find('.tooltip').text(window.languages.addWishlistText);
    }
  }

  const apiRequest = new ApiFetch();

  function checkWishlistStatus(customerInfo) {
    const wishlistElm = $('.wishlist_collections');

    apiRequest.fetcher('wishlist')
      .then(function(res) {
        if(!res?.data.length) return;

        // Update wishlist detail page
        const productDetailWishlist = $('.product__details .wishlist_collections');

        if(productDetailWishlist.length) {
          productDetailWishlist.each((_, w) => {
            const productHandle = $(w).data('product-handle');

            const handles = res.data.filter((item) => {
              return item.handle == productHandle;
            });

            const listVariantId = handles.map((v) => {
              return v.variant_id;
            })

            $(w).siblings('.input_variants').attr('data_variants', listVariantId);
          })
        }

        wishlistElm.each((_, w) => {
          const variantId = $(w).data('variant-id');

          const isActive = res.data.some((item) => {
            return item.variant_id == variantId;
          });

          updateWishlistStatus(isActive, $(w));
        });

        $('.wishlist__count').text(res?.data.length);
      })
      .fail((err) => {
        console.log('error when call api get WishlistMetafields_Partner', err);
      });
  }
  
  function getPriceForWishlist(customerInfo, listProductId, handleRenderTpl, token) {
    const storeId = window.partner.storeId.toString();

    $.ajax({
      method: 'POST',
      url: `${window.partner.omsGetPriceByListProductIds}`,
      headers: {
        'Authorization': `Bearer ${token}`,
        'issuer': storeId,
        'Accept-Language': 'en-US'
      },
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        'storeid': storeId,
        'listproductid': JSON.stringify(listProductId),
        'partnercode': customerInfo.partnerCode,
        'customeremail': customerInfo.customerEmail.toLowerCase()
      })

    }).done(function(res){
      const resultValue = JSON.parse(res?.value);
      // Update price data result
      handleRenderTpl(resultValue);

    })
    .fail(function(err) {
      handleRenderTpl();
      console.log('error when call api get price for wishlist page');
    });
  }

  function updateWishlistItemPrice(price, comparePrice, partnerPrice, wishlistItemElm) {
    const newPrice = comparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
    const oldPrice = comparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
    const discountPercent = (oldPrice - newPrice) / oldPrice * 100;

    if(partnerPrice) {
      wishlistItemElm.find('.product-content-bottom').data('new-price', newPrice);
    }

    if((comparePrice && (price === newPrice) && (comparePrice === oldPrice)) || !comparePrice && (price === newPrice)) return;

    // update price ==> format money
    if (comparePrice && oldPrice > newPrice) {
      wishlistItemElm.find(".product-item__image-container .discount").show();
      wishlistItemElm.find(".product-item__image-container .discount .price-save").html(discountPercent.toFixed(0)+"%");

      wishlistItemElm.find('.product-item__price').remove();
      
      if (!wishlistItemElm.find('.product-item__price--old').length) {
        wishlistItemElm.find('.product-content-bottom').prepend(`
          <span class="product-item__price product-item__price--old" data-money-convertible>
            ${Shopify.formatMoney(oldPrice, window.theme.moneyFormat).replace('.00', '')}
          </span>
        `)
      } else {
        wishlistItemElm.find('.product-item__price--new').html(shopify.formatMoney(oldPrice, window.theme.moneyFormat).replace('.00', ''));
      }
        
      if (!wishlistItemElm.find('.product-item__price--new').length) {
        wishlistItemElm.find('.product-content-bottom').prepend(`
          <span class="product-item__price product-item__price--new" data-money-convertible>
            ${Shopify.formatMoney(newPrice, window.theme.moneyFormat).replace('.00', '')}
          </span>
        `)
      } else {
        wishlistItemElm.find('.product-item__price--old').html(Shopify.formatMoney(newPrice, window.theme.moneyFormat).replace('.00', ''));
      }
    } 
    else {
      wishlistItemElm.find(".product-item__image-container .discount").hide();
      wishlistItemElm.find('.product-item__price').html(Shopify.formatMoney(newPrice, window.theme.moneyFormat).replace('.00', ''));
    };
  }

  function getWishlist(customerInfo){
    const wishlistContent = $('.wishlist-page .wishlist-content');

    if(!wishlistContent.length) return;

    apiRequest.fetcher('wishlist').then(function(res) {
        if(!res?.data.length) return;

        const data = res.data;

        const handleArr = data.map((item) => {
          return item.handle;
        });

        const productIds = data.map((item) => {
          return parseInt(item.product_id);
        })

        // Call api getPrice
        window.getOMSAccessToken().then((token) => {
          getPriceForWishlist(customerInfo, [...new Set(productIds)], function(priceData) {
            [...new Set(handleArr)].forEach((handle) => {           
              $.get('/products/'+ handle +'?view=wishlist', function(tpl) {
                const wishlistItem = $(tpl);
  
                wishlistContent.append(wishlistItem);
  
                const wishlistItems = wishlistContent.find('.grid__cell');
  
                wishlistItems.each((_, w) => {
                  const variantId = $(w).data('variant');
  
                  const hasWishlist = data.find((i) => {
                    return i.variant_id == variantId;
                  });
  
                  if(!hasWishlist) {
                    $(w).remove();
                  }
                  else {      
                    $(w).show();
  
                    if(priceData) {
                      // Update Price for wishlist item
                      const productItemId = $(w).find('.product-item').data('product-id').toString();
                      const productItemData = priceData.find(item => item.productid === productItemId);
    
                      if (!productItemData) return;
    
                      const variantId = $(w).find('.product-content-bottom').data('variant-id').toString();
                      const variantData = productItemData.variant.find(v => v.id === variantId);
    
                      if (!variantData) return;
    
                      const partnerOrginalPrice = variantData.price;
    
                      if(!partnerOrginalPrice) return;
    
                      const price = $(w).find('.product-content-bottom').data('price');
                      const comparePrice = $(w).find('.product-content-bottom').data('compare-price');
    
                      updateWishlistItemPrice(price, comparePrice, partnerOrginalPrice * 100, $(w));
                    }
                  }
  
                })
              })
            })
          }, token);
        }).catch(err => console.log('error when call get OMS access token', err));

      })
      .fail((err) => {
        console.log('error when call api get WishlistMetafields_Partner');
      });     
  }

  function checkoutlink() {
    $(document).on('click', '.mini-cart__buttons .checkout_link, .checkout_link', function (e) {
      $.cookie('check_out', "checkout", { expires: 1, path: '/' });
    });

    if ($.cookie('check_out') != undefined && $('.check__out').length) {
      $('body.template-customers-account').hide();
      window.location.href = "/cart";
      $.cookie('check_out', "checkout", { expires: -1, path: '/' });
    } else {
      $('body.template-customers-account').show();
      if ($('.check__out').length) {
        //  $('head title').text($("#sony-title-page").text());
      }
    }
  }

  if ($("body").hasClass("trademark--v3")) {
    checkoutlink();

    //custom product detail
    $(".product-features .block-3column").each(function () {
      var block_3column_wrapper = $(this).html();
      $(this).html("<div>" + block_3column_wrapper + "</div>");
    });
  }

  if ($("body").hasClass("template-customers-order")) {
    /**order detail**/
    var shipping_label = $(".order__items .shipping-method").attr("data-label");

    if (shipping_label != "" && shipping_label.search("Standard shipping") != -1) {
      var shipping_label_new = shipping_label.replace("Standard shipping", window.languages.standard_shipping);
      $(".order__items .shipping-method").attr("data-label", shipping_label_new);
    }
  }

  /**Edit profile**/
  function checkUserLogin() {
    var check = false;
    var user_name = "";
    if ($(".user-dropdown__item").find(".user-logined")) {
      user_name = $(".user-dropdown__item .user-logined").attr("title");

      if (user_name != undefined && user_name != "") {
        check = true;
      }
    }

    if (check == false) {
      window.location.href = $(".header__logo-link").attr("href");
    }
  }

  /***Delete Address***/
  $(".delete-address").click(function () {
    if (confirm(window.languages.delete_confirm)) {
      // your deletion code
      var address_id = $(this).attr("data-address-id");

      Shopify.postLink('/account/addresses/' + address_id, { 'parameters': { '_method': 'delete' } });
    }
    else {
      event.preventDefault();
    }

    return false;
  });

  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  function showReview(isActive) {
    var id = setInterval(check, 1000);
    var i = 0;
    var k = 1;

    function check() {
      //       console.log(i);
      if (isActive) {
        i = 9;
      }
      if (k == 5) {
        isActive = false;
      }

      if (i >= 10) {
        clearInterval(id);
      }
      else {
        if ($(window).innerWidth() > 800) {
          if (!$('#product-review-m').is(':empty')) {
            //do something
            var html = $("#product-review-m").html();
            $("#product-review").html(html);
            i = 10;
            k++;
            //             hideReviewPdp();
          }
        }
        else {
          if (!$('#product-review').is(':empty')) {
            var html = $("#product-review").html();
            $("#product-review-m").html(html);
            i = 10;
            k++;
            //            hideReviewPdp();
          }
        }
        i++;
      }
    }
  }

  /**Show review tab after clicking star**/


  window.bvCallback = function (BV) {

    BV.swat_reviews.on('show', function () {
      if ($(window).innerWidth() > 800) {
        $('.tabs__nav-item.review-tab-title').click();

        setTimeout(function () {
          $('html, body').animate({
            scrollTop: $(".product__tabs").offset().top - 100
          }, 0);

        }, 100);

      }
      else {
        if (!$(".tabs__nav-item-m > .review-tab-title").hasClass("active")) {
          $('.tabs-title.review-tab-title').click();
        }

        setTimeout(function () {
          $('html, body').animate({
            scrollTop: $(".tabs-title.review-tab-title").offset().top - 100
          }, 0);

        }, 100);

      }


      return false;

    });

  };


  /**Hide no review***/
  function hideNoRating() {
    $(".product-item").each(function () {

      //var inline_rating = $(this).find('[data-bv-show="inline_rating"]');
      var bv_text = $(this).find('.bv_text').text();


      if (bv_text != '' && bv_text != '(0)') {
        //         inline_rating.hide();
        $(this).find(".bv-ratings-block").addClass("show");
      }

    });


  }

  function hideReviewPdp() {
    if ($(".bv_numReviews_text").length) {
      if ($(".bv_numReviews_text").text() == '(0)') {
        //         $('[data-bv-show="rating_summary"]').hide();
        $(".review-tab-title").hide();
        $(".review-tab-m").parents(".tabs__nav-item-m").hide();
      }
      else {
        $(".product__meta .bv-ratings-block").addClass("show");
        $(".review-tab-title").show();
        $(".review-tab-m").parents(".tabs__nav-item-m").show();

      }

    }
  }

  function checkRating() {
    var id = setInterval(check, 1000);
    var i = 0;

    function check() {
      //       console.log("star: "+i);
      if (i >= 15) {
        clearInterval(id);
      }
      else {
        hideNoRating();
        hideReviewPdp();
        i++;
      }
    }
  }


  /**
   * js cateogry mobile
   */
  $(document).ready(function () {
    setWidthCategoryMobile();
    setColorSwatch();
    handleLogout();

    var router = new RouterRouter();

    //js free gift -- PAGE CART
    router.route('cart', function () {
      showTextCheckout();
    })

  });

  function handleLogout() {
    const logoutElm = $('[data-actions="logout"]');

    if(logoutElm.length) {
      logoutElm.on('click', function(e) {
        localStorage.removeItem('Installation');
        localStorage.removeItem('product_api');
        localStorage.removeItem('address_api');
        localStorage.removeItem('address_form');
        localStorage.removeItem('page_change_address_form');
        localStorage.removeItem('billing_form');
        localStorage.removeItem('page_change_billing_form');
        localStorage.removeItem('payment_api');
        localStorage.removeItem('delivery_method');
        localStorage.removeItem('validate_warehouse_api');
      })
    }
  }

  /**
  * js setColorSwatch
  */
  function setColorSwatch(){
    $.each($('.color-swatch'), function(i, ele){
      let styleAttr = $(ele).attr('style');
      styleAttr = removeAccents(styleAttr);

      styleAttr = styleAttr.split(':')[1].trim();
      styleAttr = styleAttr.replace(";",'');

      styleAttr = window.theme.colors[styleAttr];
      $(ele).css('background-color', styleAttr);
    })
  }

  function removeAccents(str) {
    var AccentsMap = [
      "aàảãáạăằẳẵắặâầẩẫấậ",
      "AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ",
      "dđ", "DĐ",
      "eèẻẽéẹêềểễếệ",
      "EÈẺẼÉẸÊỀỂỄẾỆ",
      "iìỉĩíị",
      "IÌỈĨÍỊ",
      "oòỏõóọôồổỗốộơờởỡớợ",
      "OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ",
      "uùủũúụưừửữứự",
      "UÙỦŨÚỤƯỪỬỮỨỰ",
      "yỳỷỹýỵ",
      "YỲỶỸÝỴ"
    ];
    for (var i=0; i<AccentsMap.length; i++) {
      var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
      var char = AccentsMap[i][0];
      str = str.replace(re, char);
    }
    return str;
  }

  /**
  * js CART-- SHOW TEXT CHECKOUT
  */
  function showTextCheckout(){
    let validate_warehouse_api = handleLocalStorage('get', 'validate_warehouse_api');
    let xhtmlValidateCheckout = '';

    if(validate_warehouse_api !== undefined){
      validate_warehouse_api = JSON.parse(validate_warehouse_api);

      if(validate_warehouse_api && !validate_warehouse_api.status){
        switch(validate_warehouse_api.message){
          case "NoRegion":
            xhtmlValidateCheckout = '<div class="page__content">This product cannot be delivered to the selected region. You can purchase this product in a seperated order.</div>';
            if (locale_theme=='vi'){
              xhtmlValidateCheckout = '<div class="page__content">Các sản phẩm trong Giỏ hàng không thể được giao trong cùng một đơn hàng. Vui lòng tách riêng đơn hàng cho các sản phẩm đó.</div>'
            }
            break;
        }

        if(xhtmlValidateCheckout != ''){
          $(xhtmlValidateCheckout).insertAfter( ".breadcrumb" );
        }
      }
    }
  }

  var setWidthCategoryMobile = function () {
    var widthBrowser = $(window).width();
    if (widthBrowser < 768) {
      var categoryItem = $(".js-list-category-mobile .category-item");
      var withcategoryItem = categoryItem.width(widthBrowser * 0.21);
      $(".shopify-section__category-list-mobile").css('display', 'block');
      $(".js-list-category-mobile").width(categoryItem.length * withcategoryItem);
    } else {
      $(".js-list-category-mobile").width('auto');
    }
  }

/**
  * JS FORM SHIPPING -- get/set localStorage
  */
function handleLocalStorage(type, key, val = null) {
  switch (type) {
    case 'set':
      localStorage.setItem(key, val);
      break;
    case 'get':
      return localStorage.getItem(key);
      break;
    default:
      break;
  }
}
}(jQuery));
